module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', [_vm._v("Dados da Pessoa")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-hover",
    attrs: {
      "role": "grid"
    }
  }, [_c('tbody', [_c('tr', {
    staticClass: "odd",
    attrs: {
      "role": "row"
    }
  }, [_vm._m(0), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.apiData.nome_razao))])]), _vm._v(" "), _c('tr', {
    staticClass: "odd",
    attrs: {
      "role": "row"
    }
  }, [_vm._m(1), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.apiData.cpf_cnpj))])]), _vm._v(" "), _c('tr', {
    staticClass: "odd",
    attrs: {
      "role": "row"
    }
  }, [_vm._m(2), _vm._v(" "), _c('td', [_vm._v("\n          " + _vm._s(_vm.apiData.telefone1 ? _vm.apiData.telefone1 : '') + "\n          " + _vm._s(_vm.apiData.telefone2 ? ' | ' + _vm.apiData.telefone2 : '') + "\n          " + _vm._s(_vm.apiData.tel_ref_comercial ? ' | ' + _vm.apiData.tel_ref_comercial : '') + "\n          " + _vm._s(_vm.apiData.tel_ref_pessoal ? ' | ' + _vm.apiData.tel_ref_pessoal : '') + "\n        ")])])])]), _vm._v(" "), _c('h4', {
    staticClass: "mt-20"
  }, [_vm._v("Boletos Pendentes")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered",
    attrs: {
      "role": "grid"
    }
  }, [_vm._m(3), _vm._v(" "), _c('tbody', [_vm._l((_vm.apiData.garantias), function(garantia) {
    return _vm._l((garantia.boletos), function(boleto) {
      return _c('tr', {
        key: boleto.id
      }, [_c('td', [_vm._v(_vm._s(garantia.usuario.empresa.fantasia))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(garantia.id) + "." + _vm._s(garantia.digito))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(boleto.id) + "." + _vm._s(boleto.digito))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dataFormatada")(boleto.vencimento)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.diasAtraso(boleto.vencimento)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("numberFormat")(boleto.valor_garantido, 2, ',', '.')) + " \n            "), _c('span', {
        staticStyle: {
          "float": "right"
        }
      }, [_c('button', {
        staticClass: "btn btn-danger btn-sm",
        attrs: {
          "title": "Incluir no SPC"
        },
        on: {
          "click": function($event) {
            return _vm.negativarCliente(boleto.id)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-fw fa-thumbs-down"
      })])])])])
    })
  })], 2), _vm._v(" "), _c('tfoot', [_c('tr', {
    staticClass: "odd",
    attrs: {
      "role": "row"
    }
  }, [_vm._m(4), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("numberFormat")(_vm.total, 2, ',', '.')))])]), _vm._v(" "), _c('tr', {
    staticClass: "odd",
    attrs: {
      "role": "row"
    }
  }, [_vm._m(5), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("numberFormat")(_vm.valorAtualizado, 2, ',', '.')))])])])]), _vm._v(" "), _c('h4', {
    staticClass: "mt-40"
  }, [_vm._v("Simulação")]), _vm._v(" "), _c('div', {
    staticClass: "row d-flex aling-flex-end"
  }, [_c('div', {
    staticClass: "col-xs-5 col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.qtdParcelas),
      expression: "dados.qtdParcelas"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dados, "qtdParcelas", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Qtd de Parcelas")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("01")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("02")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("03")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("04")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("05")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6"
    }
  }, [_vm._v("06")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "7"
    }
  }, [_vm._v("07")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8"
    }
  }, [_vm._v("08")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9"
    }
  }, [_vm._v("09")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("10")])])])]), _vm._v(" "), _vm._m(6)]), _vm._v(" "), (_vm.parcelas.length > 0) ? _c('div', [_c('table', {
    staticClass: "table table-bordered",
    attrs: {
      "role": "grid"
    }
  }, [_vm._m(7), _vm._v(" "), _c('tbody', _vm._l((_vm.parcelas), function(item, index) {
    return _c('tr', {
      key: index,
      staticClass: "odd",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_c('b', [_vm._v(_vm._s(item.parcela) + "ª Parcela")])]), _vm._v(" "), _c('td', [_c('div', {
      class: {
        'form-group': true, 'has-error': _vm.errors.has('data')
      }
    }, [_c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }, {
        name: "model",
        rawName: "v-model",
        value: (item.vencimento),
        expression: "item.vencimento"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "date",
        "name": "data"
      },
      domProps: {
        "value": (item.vencimento)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "vencimento", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('data')),
        expression: "errors.has('data')"
      }],
      staticClass: "help-block"
    }, [_vm._v("Campo obrigatório")])])]), _vm._v(" "), _c('td', [_c('div', {
      class: {
        'form-group': true, 'has-error': _vm.errors.has('valor')
      }
    }, [(index == 0) ? _c('money', _vm._b({
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      ref: "valor",
      refInFor: true,
      staticClass: "form-control",
      attrs: {
        "name": "valor"
      },
      model: {
        value: (item.valor),
        callback: function($$v) {
          _vm.$set(item, "valor", $$v)
        },
        expression: "item.valor"
      }
    }, 'money', _vm.money, false)) : _vm._e(), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('valor')),
        expression: "errors.has('valor')"
      }],
      staticClass: "help-block"
    }, [_vm._v("Campo obrigatório")])], 1)])])
  }), 0)]), _vm._v(" "), (!_vm.acordo.simulacao) ? _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.simular()
      }
    }
  }, [_vm._v("Simular")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.acordo.simulacao) ? _c('div', [_c('h4', {
    staticClass: "mt-40"
  }, [_vm._v("Resultado da Simulação")]), _vm._v(" "), _c('div', {
    staticClass: "row d-flex aling-flex-end"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Valor Atualizado")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": _vm._f("numberFormat")(_vm.valorAtualizado, 2, ',', '.')
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Desconto")]), _vm._v(" "), _c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: (_vm.acordo.desconto),
      callback: function($$v) {
        _vm.$set(_vm.acordo, "desconto", $$v)
      },
      expression: "acordo.desconto"
    }
  }, 'money', _vm.money, false))], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Valor total do parcelamento")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": _vm._f("numberFormat")(_vm.acordo.totalParcelamento, 2, ',', '.')
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "btn btn-primary mt-20",
    on: {
      "click": function($event) {
        return _vm.simular()
      }
    }
  }, [_vm._v("Refazer Simulação")])])]), _vm._v(" "), (_vm.parcelas.length > 0) ? _c('div', {
    staticClass: "mt-20"
  }, [_c('table', {
    staticClass: "table table-bordered",
    attrs: {
      "role": "grid"
    }
  }, [_vm._m(8), _vm._v(" "), _c('tbody', _vm._l((_vm.acordo.parcelas), function(item, index) {
    return _c('tr', {
      key: index,
      staticClass: "odd",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_c('b', [_vm._v(_vm._s(item.parcela) + "ª Parcela")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dataFormatada")(item.vencimento)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("numberFormat")(item.valor, 2, ',', '.')))])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('button', {
    staticClass: "btn btn-defalt",
    on: {
      "click": function($event) {
        return _vm.cancelarSimulacao()
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.efetivarAcordo()
      }
    }
  }, [_vm._v("Efetivar Acordo")])])]) : _vm._e()]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('b', [_vm._v("Nome/Razão:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('b', [_vm._v("Cpf/Cnpj:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('b', [_vm._v("Telefones:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Empresa")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Protocolo")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Garantia")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Vencimento")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Dias de Atraso")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Valor")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "text-right",
    attrs: {
      "colspan": "5"
    }
  }, [_c('b', [_vm._v("Total do débito sem Juros")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "text-right",
    attrs: {
      "colspan": "5"
    }
  }, [_c('b', [_vm._v("Valor atualizado")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-7 col-md-9"
  }, [_c('p', {}, [_vm._v("Simulação: 2% de multa + 14,90(taxa de administração) + juros de 0,33% ao dia para boletos ou 0,033% ao dia para cheques.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Parcela")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Vencimento")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Valor")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Parcela")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Vencimento")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Valor")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7256222a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cobranca/inadimplentes/inadimplenteAcordo.vue
// module id = 405
// module chunks = 1